

function convertRGBColorByPixel (imageFrame, rgbaBuffer) {
  if (imageFrame === undefined) {
    throw 'decodeRGB: rgbBuffer must not be undefined';
  }
  if (imageFrame.length % 3 !== 0) {
    throw 'decodeRGB: rgbBuffer length must be divisible by 3';
  }

  const numPixels = imageFrame.length / 3;
  let rgbIndex = 0;
  let rgbaIndex = 0;

  for (let i = 0; i < numPixels; i++) {
    rgbaBuffer[rgbaIndex++] = imageFrame[rgbIndex++]; // red
    rgbaBuffer[rgbaIndex++] = imageFrame[rgbIndex++]; // green
    rgbaBuffer[rgbaIndex++] = imageFrame[rgbIndex++]; // blue
    rgbaBuffer[rgbaIndex++] = 255; // alpha
  }
}

export default convertRGBColorByPixel;



// WEBPACK FOOTER //
// ./imageLoader/colorSpaceConverters/convertRGBColorByPixel.js